import React, { useState, useRef, useEffect } from "react";
import { Formik } from "formik";
import { Button, FormGroup, Label, Row, Col } from "reactstrap";
import * as Yup from "yup";
import { cloneDeep } from "lodash";
import CoveredEntity from "components/CoveredEntity";
import NPIProviderList from "components/NPIProviderList";

const validationSchema = Yup.object({
  coveredEntityName: Yup.string().required("Please select covered entity"),
});

const SearchContainer = (props) => {
  const {
    filterBySearch,
    onSearch,
    onReset,
    providerFilters,
    handleUpdateEntity,
  } = props;

  const formikRef = useRef();

  const [selectedCoveredEntity, setSelectedCoveredEntity] = useState({});
  const [selectedProvider, setSelectedProvider] = useState(null);

  useEffect(() => {
    if (providerFilters) {
      setPreValue();
    }
  }, []);

  const setPreValue = () => {
    if (formikRef.current) {
      const { setFieldValue } = formikRef.current;
      const { coveredEntityName } = providerFilters;
      setFieldValue(
        "coveredEntityName",
        coveredEntityName ? parseInt(coveredEntityName) : ""
      );
    }
  };

  const handleSubmit = async (val, actions) => {
    const { setSubmitting } = actions;
    const values = cloneDeep(val);
    values.providerID = selectedProvider;
    await onSearch(values);
    setSubmitting(false);
  };

  const handleCoverdEntityChange = async (value, setFieldValue, entity) => {
    handleUpdateEntity(entity);
    setFieldValue("coveredEntityName", value);
    setSelectedCoveredEntity(entity);
    setSelectedProvider(null);
  };

  const onSelect = (provider) => {
    setSelectedProvider(provider);
  };

  const handleReset = ({ resetForm }) => {
    resetForm();
    onReset();
    setSelectedProvider(null);
  };

  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={filterBySearch}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        children={(props) => {
          const { isSubmitting, handleSubmit, resetForm, setFieldValue } =
            props;
          return (
            <div>
              <h5 className="f-15 text-primary font-weight-700">
                Search Providers
              </h5>
              <Row sm={5}>
                <Col md={2} sm={3} xs={6}>
                  {" "}
                  <FormGroup>
                    <Label for="coveredEntityID">Covered Entity</Label>
                    <CoveredEntity
                      name="coveredEntityName"
                      onChange={(value, enty) =>
                        handleCoverdEntityChange(value, setFieldValue, enty)
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={2} sm={3} xs={6}>
                  <FormGroup>
                    <Label>NPI/Provider Name</Label>
                    <NPIProviderList
                      tenantID={selectedCoveredEntity.tenantID}
                      onSelect={onSelect}
                      selectedProvider={selectedProvider}
                    />
                  </FormGroup>
                </Col>

                <Col md="auto" className="pt-4 mt-1">
                  <Label>{""}</Label>
                  <Button
                    disabled={isSubmitting}
                    onClick={handleSubmit}
                    color="primary"
                    className="ms-3"
                  >
                    Search
                  </Button>
                  <Button color="primary" onClick={() => handleReset(props)}>
                    Reset
                  </Button>
                </Col>
              </Row>
            </div>
          );
        }}
      ></Formik>
    </>
  );
};

export default SearchContainer;
